// extracted by mini-css-extract-plugin
export var additionalLink = "mobile-menu-module--additionalLink--8bd81";
export var additionalLinkContainer = "mobile-menu-module--additionalLinkContainer--25768";
export var additionalLinkLabel = "mobile-menu-module--additionalLinkLabel--665f4";
export var drawer = "mobile-menu-module--drawer--efc5f";
export var drawerInner = "mobile-menu-module--drawerInner--fd17c";
export var menuItem = "mobile-menu-module--menuItem--ff013";
export var menuList = "mobile-menu-module--menuList--3d2d4";
export var noticeBarVisible = "mobile-menu-module--noticeBarVisible--dbb07";
export var reveal = "mobile-menu-module--reveal--8bd7b";
export var settleIn = "mobile-menu-module--settleIn--16ba4";